import { modal } from "@gtmhub/core/routing";

export const teamProfile = modal({
  name: ".team",
  url: ":teamId/team-details/?focusSelectManagerFiled",
  data: {
    trackingPage: "Team Details",
  },
  component: "teamProfile",
  windowClass: "profile-sidebar",
});

export const teamMembers = modal({
  name: ".members",
  url: ":teamRole/",
  data: {
    trackingPage: "Team Role",
  },
  component: "teamMembers",
  windowClass: "profile-sidebar",
});
